import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../../../../store';
import type { TestAlarmState } from './types';

const initialState: TestAlarmState = {
  testId: null,
  testAlarmSentAt: null,
  lastReceivedTestId: null,
  isLoading: false,
};

const testAlarmSlice = createSlice({
  name: 'tesAlarm',
  initialState,
  reducers: {
    setTestId: (state, action: PayloadAction<number | null>) => {
      state.testId = action.payload;
    },
    setIsTestAlarmLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setTestAlarmSentAt: (state, action: PayloadAction<number | null>) => {
      state.testAlarmSentAt = action.payload;
    },
    setLastReceivedTestId: (state, action: PayloadAction<number | null>) => {
      state.lastReceivedTestId = action.payload;
    },
    clearTestAlarmState: () => initialState,
  },
});

export const {
  setTestId,
  setIsTestAlarmLoading,
  setTestAlarmSentAt,
  setLastReceivedTestId,
  clearTestAlarmState,
} = testAlarmSlice.actions;

export const getTestId = (state: RootState) => state.testAlarm.testId;
export const getIsLoading = (state: RootState) => state.testAlarm.isLoading;
export const getTestAlarmSentAt = (state: RootState) => state.testAlarm.testAlarmSentAt;
export const getLastReceivedTestId = (state: RootState) => state.testAlarm.lastReceivedTestId;

export default testAlarmSlice.reducer;
